import 'jquery-colorbox';
import { getExperience } from '@gcc/autobahn-utilities';
import globals from 'globals';
import ko from '../../../vendor/knockout';
import MixedCartViewModel from '../../../content/mixed-cart/view-models/mixed-cart-view-model';
import '../../../binding-handlers/blur-handle';

const cartViewModel = new MixedCartViewModel();
ko.applyBindings(cartViewModel, document.querySelector('.bdc-cart'));
window.getExperience = getExperience;
window.addEventListener('DOMContentLoaded', () => {
  // Add the express pay buttons (PayPal, Apple Pay) through the view model.
  cartViewModel.addExpressPayButtons();

  // Auto apply promo if applicable
  cartViewModel.autoApplyBestPromo();

  cartViewModel.registerScroll();

  function sessionSet(key, value, expirationInMin = 10) {
    const expirationDate = new Date(new Date().getTime() + (60000 * expirationInMin));
    const newValue = {
      value,
      expirationDate: expirationDate.toISOString(),
    };
    window.sessionStorage.setItem(key, JSON.stringify(newValue));
  }

  function onVisible(element, callback) {
    new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          callback(element);
          observer.disconnect();
        }
      });
    }).observe(element);
  }

  onVisible(document.querySelector('#gcc-cart-proceed-to-checkout-bottom'), () => {
    if (globals.siteId === 3) {
      sessionSet('paypalSession', true, 60);
      setInterval(() => {
        cartViewModel.proceedToCheckout(false);
      }, 60000 * 30);
    }
  });
});
